// extracted by mini-css-extract-plugin
export default {"tabBar":"StockTabs_tabBar__FSpkZ","tab":"StockTabs_tab__moUJ4","tabActive":"StockTabs_tabActive__BS6ZM","tabIcon":"StockTabs_tabIcon__2uNsD"};